import React, { useMemo } from 'react';
import RoleDashboardTemplate from './RoleDashboardTemplate';
import { useAuth } from '../../context/AuthContext';
import { buildRoleWorkspaceModules } from '../../config/roleWorkspaceConfig';

const AccountantDashboardPage = () => {
  const auth = useAuth();
  const modules = useMemo(() => buildRoleWorkspaceModules('accountant', auth), [auth]);

  return (
    <RoleDashboardTemplate
      title="Accountant Dashboard"
      subtitle="Operational accounting workspace for accurate and timely records."
      modules={modules}
    />
  );
};

export default AccountantDashboardPage;
